(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[680],{

/***/ "1Nt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Off", function() { return Off; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Off = function Off(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M250,0 C388.071188,0 500,111.928812 500,250 C500,388.071188 388.071188,500 250,500 C111.928812,500 0,388.071188 0,250 C0,111.928812 111.928812,0 250,0 Z M250,111.111111 C173.293788,111.111111 111.111111,173.293788 111.111111,250 C111.111111,326.706213 173.293788,388.888888 250,388.888888 C326.706213,388.888888 388.888888,326.706213 388.888888,250 C388.888888,173.293788 326.706213,111.111111 250,111.111111 Z"
  }));
};

/***/ })

}]);